/** 0:32 style time. `tenths` adds one decimal: 0:32.4 */
export function formatTime(s: number, tenths = false): string {
  const t = Math.max(0, s);
  const m = Math.floor(t / 60);
  const sec = t - m * 60;
  return tenths ? `${m}:${sec.toFixed(1).padStart(4, '0')}` : `${m}:${String(Math.floor(sec)).padStart(2, '0')}`;
}
